import { unionSchema, yup } from '@framework/validation';
import { ExpressionType } from '../../IExpression';
import { ConditionExpressionType } from '../condition/ConditionExpression.type';
import { FunctionExpressionType } from '../function/FunctionExpression.type';
import {
  ConditionGroupOperator,
  IConditionGroupExpression,
  IConditionItem,
} from './IConditionGroupExpression';

export const ConditionGroupExpressionSchema: yup.ObjectSchema<IConditionGroupExpression> =
  yup
    .object({
      type: yup
        .string()
        .exact(ExpressionType.ConditionGroup)
        .required()
        .transform(() => ExpressionType.ConditionGroup),
      operator: yup
        .string()
        .oneOfEnum(ConditionGroupOperator)
        .default(ConditionGroupOperator.And)
        .label('Operazione')
        .required(),
      conditions: yup
        .array<any, IConditionItem>(
          yup.lazy(
            () =>
              unionSchema([
                ConditionGroupExpressionSchema,
                ConditionExpressionType.schema,
                FunctionExpressionType.schema,
              ]) as yup.Lazy<IConditionItem>,
          ),
        )
        .default([])
        .label('Condizioni')
        .required(),
    })
    .meta({ expression: ExpressionType.ConditionGroup });
